const ArrayUtils = {
    /**
     * @param {Array} arr
     * @param {*} object
     * @param {*} replace
     */
    delete(arr, object, replace = null) {
        if (replace) {
            arr.splice(arr.indexOf(object), 1, replace);
        } else {
            arr.splice(arr.indexOf(object), 1);
        }
    },
};

export default ArrayUtils
